import { TCRBrandIdentityStatus } from '@weave/schema-gen-ts/dist/schemas/tendlc/shared/v1/shared.pb';
import { TenCoordinatorV1 } from '@frontend/api-tendlc-coordinator';

type Props = {
  locationIds: string[];
};

export const useBrandVerification = ({ locationIds }: Props) => {
  const { data: brandCompliance } = TenCoordinatorV1.Queries.useGetLocationsBrandComplianceQuery({
    locationIds,
  });

  const filteredLocationIds = brandCompliance?.locationBrandCompliances
    .filter((item) => !item.isCanada && !item.isSoleProprietor)
    .map((item) => item.locationId);

  const { data: tcrBrandsData } = TenCoordinatorV1.Queries.useGetLocationsTCRBrandsQuery({
    locationIds,
  });

  const { data: registrationStatusesData } = TenCoordinatorV1.Queries.useGetLocationsRegistrationStatusesQuery(
    { locationIds: filteredLocationIds ?? [] },
    { enabled: !!filteredLocationIds && filteredLocationIds.length > 0 }
  );

  const unverifiedCount = tcrBrandsData?.locationTcrBrands?.filter(
    ({ tcrBrand }) =>
      tcrBrand?.identityStatus !== TCRBrandIdentityStatus.TCR_BRAND_IDENTITY_STATUS_VERIFIED &&
      tcrBrand?.identityStatus !== TCRBrandIdentityStatus.TCR_BRAND_IDENTITY_STATUS_VETTED_VERIFIED
  ).length;

  const unregisteredCount =
    registrationStatusesData?.locationsRegistrationStatuses?.filter(({ registered }) => !registered).length ?? 0;

  return {
    unverifiedCount,
    unregisteredCount,
    isMissingBusinessInfo: !!unverifiedCount && !!unregisteredCount,
  };
};
